var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import SkillGroupHeading from "./SkillGroupHeading";
import SkillGroupAccordion from "./SkillGroupAccordion/SkillGroupAccordion";
var SuccessProfilesSkillGroup = function (props) {
    return (_jsxs("div", __assign({ "data-testid": "skill-group-container" }, { children: [_jsx(SkillGroupHeading, { title: props.title, description: props.description }), _jsx(SkillGroupAccordion, { progressStepperFactory: props.progressStepperFactory, accordionData: props.skillData, clientEdits: props.clientEdits })] })));
};
export var SuccessProfileDataGroup = function (_a) {
    var _b;
    var clientId = _a.clientId, roleProfileId = _a.roleProfileId, progressStepperFactory = _a.progressStepperFactory, title = _a.title, name = _a.name, useData = _a.useData, edits = _a.edits;
    var skillGroupData = useData(clientId, roleProfileId, name);
    var clientEdits = ((_b = edits.current) === null || _b === void 0 ? void 0 : _b[clientId]) || {};
    return (_jsx(SuccessProfilesSkillGroup, { title: title, description: skillGroupData.description, progressStepperFactory: progressStepperFactory, skillData: skillGroupData.skills, clientEdits: clientEdits }));
};
export default SuccessProfilesSkillGroup;
